import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';
import { ThemeToggle } from '../ui/theme-toggle';
import { Spinner } from '../ui/spinner';

const AuthLayout = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background ">
      <div className="absolute right-4 top-4">
        <ThemeToggle />
      </div>
      <div className="w-full bg-card">
        <Suspense
          fallback={
            <div className="flex h-screen w-full items-center justify-center">
              <Spinner showSpinner />
            </div>
          }
        >
          <Outlet />
        </Suspense>
      </div>
    </div>
  );
};

export default AuthLayout;